import {takeEvery} from 'redux-saga/effects'
import {
  CLEAR_ROYALTY_INVOICE,
  DELETE_ROYALTY_INVOICE,
  FETCH_DUPLICATE_INVOICE,
  GENERATE_ROYALTY_INVOICE,
  GET_FEE_BANK_ACCOUNTS,
  GET_FEE_COLLECTION_MONTHS_YEARS,
  GET_FEE_PARTICULARS,
  GET_ROYALTY_INVOICES,
  GET_ROYALTY_SETTINGS,
  GET_SINGLE_INVOICE,
  PRINT_ROYALTY_PDF,
  UPDATE_ROYALTY_INVOICE,
  UPDATE_ROYALTY_SETTINGS,
} from 'setup/redux/Actions/Royalty/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_FEE_COLLECTION_MONTHS_YEARS, fetchData)
  yield takeEvery(GET_FEE_PARTICULARS, fetchData)
  yield takeEvery(GET_FEE_BANK_ACCOUNTS, fetchData)
  yield takeEvery(GENERATE_ROYALTY_INVOICE, fetchData)
  yield takeEvery(FETCH_DUPLICATE_INVOICE, fetchData)
  yield takeEvery(GET_ROYALTY_INVOICES, fetchData)
  yield takeEvery(PRINT_ROYALTY_PDF, fetchData)
  yield takeEvery(GET_SINGLE_INVOICE, fetchData)
  yield takeEvery(UPDATE_ROYALTY_INVOICE, fetchData)
  yield takeEvery(GET_ROYALTY_SETTINGS, fetchData)
  yield takeEvery(UPDATE_ROYALTY_SETTINGS, fetchData)
  yield takeEvery(DELETE_ROYALTY_INVOICE, fetchData)
  yield takeEvery(CLEAR_ROYALTY_INVOICE, fetchData)
}

export default dataSaga
